import { AppData } from "@lightningjs/sdk";
import { Helper } from "../helper";
import { Logger } from "../logger";
import CuePoint from "./cuepoint";
import { AppSetup } from "../app-setup";
import { AppState } from "../app-state";

class CuePointsManager {
    noPreAds:any
    noMidAds:any
    noMidAdsCopy:any    
    adProviders:any
    cuePoints:any
    videoInfo:any
    adsLoader:any
    adHandler:any
    adEventsCallbackHandler:any    
    currentBreakPosition:any
    contentDuration:any


    /**
     * @description - Creates holds the cuepoint list for the single video.
     * It checks for the video timeline and automaticaly prefetches ads and playes ads in the cue points.
     * @param  {Object} options
     * @param  {Object} adsLoader Ima adsLoader object.
     * @param  {} adEventsCallbackHandler Ad event handler  
     */
    constructor(options:any, adsLoader:any, adEventsCallbackHandler:any, videoInfo:any, adHandler:any) {
        this.noPreAds = 2;
        this.noMidAds = 5;
        this.adProviders = [];
        this.cuePoints = [];
        this.videoInfo = videoInfo;

        this.adsLoader = adsLoader;
        this.adHandler = adHandler;
        this.adEventsCallbackHandler = adEventsCallbackHandler;
        
        this.currentBreakPosition = 0;
        this.noMidAdsCopy = 5;

        if (options) {
            if (options.noPreAds !== undefined || options.noPreAds == null) {
                this.noPreAds = options.noPreAds;
            }
            if (options.noMidAds) {
                this.noMidAds = options.noMidAds;
                this.noMidAdsCopy = options.noMidAds;
            }
            if (options.adProviders) {
                this.adProviders = options.adProviders;
            }
            if (options.contentDuration) {
                this.contentDuration = options.contentDuration;
            }
            if (options.cuePoints) {
                this.cuePoints = this.generateCuePoints(options.cuePoints);
            }
            if (options.videoInfo) {
                this.videoInfo = options.videoInfo;
            }
        }        
    }

    /**
     * @description Generates cue points instances  of CuePoint class.
     * @param  {Array} cuePoints array of cue points form the content video.
     * @returns {Array} Array of CuePoint instances.
     */
    generateCuePoints = (cuePoints:any) => {
        var cuePointsList = [];
        for (var i = 0; i < cuePoints.length; i++) {
            var cuePointTime = cuePoints[i];
            var cuePointType = 'midroll';
            if (cuePointTime == 0 || cuePointTime == '0') {
                cuePointType = 'preroll';
            }
            var cuePointObj = new CuePoint(cuePointTime, cuePointType, this.videoInfo, this.adEventsCallbackHandler, this.adHandler);
            cuePointsList.push(cuePointObj);
        }
        return cuePointsList;
    }

    /**
     * @param  {Number} cuePointTime cuePointTime value.
     * @returns  {CuePoint} {varcuePoint=this.cuePoints[i];if(cuePoint.cuePointTime==cuePointTime
     */
    getCuePoint = (cuePointTime:any) => {
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            if (cuePoint.cuePointTime == cuePointTime)
                return cuePoint;
        }
        return null;
    }

    /**
     * @description Starts the request on the current cue point.
     * @param  {Number} cuePointTime Next comming up cue position in current video.
     * @param  {Boolean} playImmediatly Start the add on the first pod Load method or error method.
     */
    requestAds = (cuePointTime:any, playImmediatly:any) => {        
        const { appConfig, appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();                
        var cuePoint = this.getCuePoint(cuePointTime);
        if (cuePoint !== null) {
            var breakPointPos = cuePoint.cuePointType == 'preroll' ? 0 : ++this.currentBreakPosition;
            this.noMidAds = this.noMidAdsCopy;
            if(appConfig?.adSdkToUse=="ima"){
                if(breakPointPos==1){
                    this.noMidAds = Number(appApiConfig?.appConfig?.firstmidrollsize);
                }
            }
            var noOfAds = cuePoint.cuePointType == 'preroll' ? this.noPreAds : this.noMidAds;
            cuePoint.requestAds(noOfAds, this.adProviders, this.adsLoader, playImmediatly, breakPointPos);
        }        
    }    

    /**
     * @description Retrives the cuepoint instance at the given time.
     * @param  {Number} currTime
     */
    getNextCuePoint = (currTime:any) => {
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            var cuePointTime = Number(cuePoint.cuePointTime);
            if (cuePointTime >= currTime) {
                return cuePoint;
            }
        }
        return null;
    }

    /**
     * @param  {} currTime
     */
    updateCurrentTime = (currTime:any, updateSessionTime = true) => {
        var nextCuePoint = this.getNextCuePoint(currTime);
        if (!nextCuePoint) return;
        var threashold = nextCuePoint.cuePointTime - currTime;
        //Triggring the ad request for prefetching.
        ////logger.printLog('data', 'updateCurrentTime: next cuepoint, currTime, threashold: ', [nextCuePoint, currTime, threashold]);
        if (!nextCuePoint.initiatedPrefetch && nextCuePoint.cuePointTime - currTime <= 20) {
            //logger.printLog('data', 'CuePointsManager: Ad Request Triggered next cuepoint, currTime, threashold: ', [nextCuePoint, currTime, threashold]);
            
            const {appState} = AppData as AppSetup
            // this is cruital to record the time played. till the request is fetched.
            // consider user plays from start starttime will be 0, on request we need to update sessiontime so the time is send in the macro.
            if(updateSessionTime) {
                appState?.sessionTimeState.updateTimer('update');
            }
            this.requestAds(nextCuePoint.cuePointTime,false);
            this.clearUnplayedCuePoints(currTime);
        }

        //For Triggering the


        if (threashold < 1 && !nextCuePoint.initiatedAdPlay) {
            //logger.printLog('data', 'CuePointsManager: Ad play Triggered: next cuepoint, currTime, threashold: ', [nextCuePoint, currTime, threashold]);
            nextCuePoint.startAd();
        }


    }

    /**
     * Initiates a prefetch VAST ad request for a specific cue point.
     *
     * This function checks if a cue point exists for the given time, determines
     * the number of ads to request based on whether it's a preroll or midroll,
     * replaces macros in the ad tag URL, and sends a prefetch request using the 
     * provided helper method.
     *
     * @param {any} cuePointTime - The timestamp used to locate the relevant cue point.
     *
     * @returns {void}
     *
     * @example
     * requestFusePrefetch(120); // Prefetch ad at 2:00 mark
     */
    requestFusePrefetch = async (cuePointTime:any) => {
        const { appState, platform } = AppData as AppSetup;
        var cuePoint = this.getCuePoint(cuePointTime);
        if (cuePoint !== null) {
            var breakPointPos = cuePoint.cuePointType == 'preroll' ? 0 : this.currentBreakPosition+1;
            this.noMidAds = this.noMidAdsCopy;
            if(breakPointPos==1){
                const appApiConfig = appState?.getAppApiConfig();
                this.noMidAds = Number(appApiConfig?.appConfig?.firstmidrollsize);
            }
            var noOfAds = cuePoint.cuePointType == 'preroll' ? this.noPreAds : this.noMidAds;
            console.log('FUSE PF noOfAds,breakPointPos ',noOfAds,breakPointPos);
            console.log('FUSE PF this.adProviders ',this.adProviders);
            console.log('FUSE PF this.adProviders ',this.adsLoader);
            var url = this.adProviders[0].url;
            var urlWithReplacedMacros = ''
            if(url){
                appState?.sessionTimeState.updateTimer('update');
                // VegaOS (FireTV) - this prefetch builds its own ad URL directly, ahead of the prefetch request
                var apsKey = `${cuePoint.cuePointType}:${breakPointPos}`;
                await platform?.requestApsBid(this.adHandler.apsBid, apsKey, cuePoint.cuePointType, cuePoint.videoInfo);
                urlWithReplacedMacros = this.adHandler.replaceMacros(url, cuePoint.cuePointType, breakPointPos, 1, cuePoint.cuePointTime)
                this.adHandler.dedupeId = Helper.getQueryParamValueFromUrl(urlWithReplacedMacros,'FT_DEDUPE_ID')
                //this.adProviders[0].url = urlWithReplacedMacros
                urlWithReplacedMacros = urlWithReplacedMacros + `&PREFETCH_SECOND_REQUEST=false&FT_PREFETCH_REQUEST=1`;
                Logger.printLog('info','FUSE PF this.adProviders ',urlWithReplacedMacros);
                Helper.sendFusePrefetchRequest(urlWithReplacedMacros)
            }
            //cuePoint.requestAds(noOfAds, this.adProviders, this.adsLoader, false, breakPointPos);
        }        
    }

    hitRequestTrackers=()=>{
        var nextCuePoint = this.getNextCuePoint(currTime);
        if (!nextCuePoint) return;
        nextCuePoint.hitRequestTrackers();
        
    }

    clearUnplayedCuePoints = (currTime:any) => {
        var nextCuePoint = this.getNextCuePoint(currTime);
        if (!nextCuePoint) return;
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            if (cuePoint.cuePointTime !== nextCuePoint.cuePointTime &&
                cuePoint.initiatedPrefetch && !cuePoint.started) {
                cuePoint.resetPrefetch();
            }
        }
    }

    skipCurrentAd = () => {
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            if (cuePoint.state == 'started') {
                cuePoint.skipCurrentAd();
                return;
            }
        }
    }

    pause = () => {
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            if (cuePoint.state == 'playing') {
                cuePoint.pause();
                return;
            }
        }
    }

    resume = () => {
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            if (cuePoint.state == 'playing') {
                cuePoint.resume();
                return;
            }
        }
    }

    destroy = () => {
        for (var i = 0; i < this.cuePoints.length; i++) {
            var cuePoint = this.cuePoints[i];
            cuePoint.destroy();
        }
        this.cuePoints = null;
        this.adsLoader = null;
        this.adHandler = null;
        this.adEventsCallbackHandler = null;
    }
}

export default CuePointsManager;